import initialState from './../../initialState';

const sortAsc = name => (a, b) => -(a[name] < b[name]) || +(a[name] !== b[name]);

const montaTabela = ({ result }) => {
  let output = result.reduce((s, { status, ...otherTask}) => {
    if (!(otherTask.nome_tarefa in s.tarefas)) {
      s.tarefas[otherTask.nome_tarefa] = {
        ...otherTask,
        id: otherTask.id_tarefa,
        nome: otherTask.nome_tarefa,
        perfis: {}
      };
    }
    if (!(otherTask.id_perfil in s.tarefas[otherTask.nome_tarefa].perfis)) {
      s.tarefas[otherTask.nome_tarefa].perfis[otherTask.id_perfil] = {
        ...otherTask,
        id: otherTask.id_perfil,
        nome: otherTask.nome_perfil,
        dias: []
      };
    }
    if (!(otherTask.id_perfil in s.perfis)) {
      s.perfis[otherTask.id_perfil] = {
        ...otherTask,
        id: otherTask.id_perfil,
        nome: otherTask.nome_perfil,
        dias_semana: [0, 0, 0, 0, 0, 0, 0]
      };
    }
    if (status) {
      s.perfis[otherTask.id_perfil].dias_semana[otherTask.dia_semana] += otherTask.estimativa;
    }
    s.tarefas[otherTask.nome_tarefa].perfis[otherTask.id_perfil].dias[otherTask.dia_semana] = { status, ...otherTask };

    return s;
  }, { tarefas: {}, perfis: {} });

  output.tarefas = Object.values(output.tarefas).map(tarefa => ({
    ...tarefa,
    perfis: Object.values(tarefa.perfis).sort(sortAsc("nome"))
  })).sort(sortAsc("prioridade"));

  output.perfis = Object.values(output.perfis).map(perfil => ({
    ...perfil
  })).sort(sortAsc("nome"));

  return output;
}

export default (state = initialState.agenda, { type, value, response }) => {
  let index,result;
  switch (type) {
    case 'LIST_QRCODE_TASKS_REQUEST':
      return {
        ...state,
        qrcodes: {
          ...state.qrcodes,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_QRCODE_TASKS_SUCCESS':
      return {
        ...state,
        qrcodes: {
          ...state.qrcodes,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_ALL_TASKS_REQUEST':
      return {
        ...state,
        todasAtividades: {
          ...state.todasAtividades,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_ALL_TASKS_SUCCESS':
      return {
        ...state,
        todasAtividades: {
          ...state.todasAtividades,
          fetching: 2,
          ...response
        }
      };
    case 'LIST_CONFIG_TASKS_REQUEST':
      return {
        ...state,
        config: {
          ...state.config,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_CONFIG_TASKS_SUCCESS':
      return {
        ...state,
        config: {
          ...state.config,
          fetching: 2,
          ...response,
          result: montaTabela(response)
        }
      };
    case 'LIST_CONFIG_PERFIS_TASKS_REQUEST':
      return {
        ...state,
        config_perfis: {
          ...state.config_perfis,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_CONFIG_PERFIS_TASKS_SUCCESS':
      return {
        ...state,
        config_perfis: {
          ...state.config_perfis,
          fetching: 2,
          ...response,
        }
      };
    case 'LIST_TASK_REQUEST':
      return {
        ...state,
        atividades: {
          ...state.atividades,
          fetching: 1,
          errors: []
        }
      };
    case 'LIST_TASK_SUCCESS':
      return {
        ...state,
        atividades: {
          ...state.atividades,
          fetching: 2,
          ...response
        }
      };
    case 'CONFIRM_TASK_REQUEST':
      index = state.atividades.result.findIndex(v => v === value);
      result = state.atividades.result;
      result.splice(index, 1);

      return {
        ...state,
        atividades: {
          ...state.atividades,
          fetching: 1,
          complete: index,
          result
        }
      };
    case 'CONFIRM_TASK_SUCCESS':
      return {
        ...state,
        atividades: {
          ...state.atividades,
          fetching: 2
        }
      };
    case 'CONFIRM_TASK_FAILURE':
      result = state.atividades.result;
      result.splice(state.atividades.complete, 0, value);

      return {
        ...state,
        atividades: {
          ...state.atividades,
          fetching: 2,
          result
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/agenda/reducer.js